import { render } from "./UnitsCount.vue?vue&type=template&id=59c01dcf&scoped=true"
import script from "./UnitsCount.vue?vue&type=script&lang=js"
export * from "./UnitsCount.vue?vue&type=script&lang=js"

import "./UnitsCount.vue?vue&type=style&index=0&id=59c01dcf&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c01dcf"]])

export default __exports__